import Link from 'next/link';
import Logo from '@/components/Logo';
import { SITE } from '@/lib/site';

export default function Footer() {
  return (
    <footer className="bg-forest-950 text-white/60">
      <div className="wrap grid gap-12 py-16 md:grid-cols-12">
        <div className="md:col-span-5">
          <Logo light />
          <p className="mt-6 max-w-xs text-sm leading-relaxed">
            체계적인 커리큘럼으로
            <br />
            영어 실력 향상을 약속합니다.
          </p>
        </div>

        <div className="md:col-span-4">
          <p className="text-sm font-bold text-white">Contact</p>
          <ul className="mt-4 space-y-2 text-sm">
            <li>
              {SITE.address} {SITE.addressDetail}
            </li>
            <li>
              <a href={`tel:${SITE.phone}`} className="hover:text-white">
                {SITE.phone}
              </a>
            </li>
            <li>
              <a href={`mailto:${SITE.email}`} className="hover:text-white">
                {SITE.email}
              </a>
            </li>
          </ul>
        </div>

        <div className="md:col-span-3">
          <p className="text-sm font-bold text-white">Hours</p>
          <dl className="mt-4 grid grid-cols-[56px_1fr] gap-y-2 text-sm">
            {SITE.hours.map((h) => (
              <div key={h.day} className="contents">
                <dt className="text-white/40">{h.day}</dt>
                <dd>{h.time}</dd>
              </div>
            ))}
          </dl>
        </div>
      </div>

      <div className="border-t border-cream/10">
        <div className="wrap flex flex-col gap-3 py-6 text-xs text-white/40 sm:flex-row sm:items-center sm:justify-between">
          <p>
            &copy; {new Date().getFullYear()} {SITE.nameEn}. All rights reserved.
          </p>
          <div className="flex gap-5">
            <Link href="/curriculum" className="hover:text-white">커리큘럼</Link>
            <Link href="/enrollment" className="hover:text-white">수강신청</Link>
            <Link href="/contact" className="hover:text-white">문의하기</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
